module.exports = __webpack_public_path__ + "img/icon_needs.e927f591.svg";